import React, {useEffect, useState} from 'react';

import CurrencySwitchItem from './CurrencySwitchItem';

const CurrencySwitch = ({name, currencies, defaultCurrency = 'EUR'}) => {
    const [currency, setCurrency] = useState(defaultCurrency);

    useEffect(
        () => {
            const [...nodes] = document.querySelectorAll('.currency');

            nodes.forEach(node => {
                node.style.display = node.classList.contains(currency) ? 'initial' : 'none';
            });
        },
        [currency],
    );

    return (
        <div className="currency-switch-container">
            <input type="hidden" name={name} value={currency} />
            {currencies.map(({value, label}) => (
                <CurrencySwitchItem
                    key={value}
                    value={value}
                    label={label}
                    active={value === currency}
                    setCurrency={setCurrency}
                />
            ))}
        </div>
    );
}

export default CurrencySwitch;
